module.exports = __webpack_public_path__ + "static/media/ball_3_7.418db0a8.mp3";